module.exports = __webpack_public_path__ + "static/media/college-writing-i-enrolled.7a3ce008.svg";